import antdJA from 'antd/locale/ja_JP';
import common from './common_jp.json';
import signin from './signin.json';

const jaLang = {
  messages: {
    ...common,
  },
  antd: antdJA,
  locale: 'ja_JP',
};
export default jaLang;
